import { Link } from 'react-router-dom';
import { path } from './router';

export default function AppLink(props) {
  const {
    children,
    href,
    className = '',
    target = '_self',
  } = props;

  if (href)
    return (
      <a href={href} className={className} target={target}>
        {children}
      </a>
    );

  return (
    <Link
      to={path({ name: props.path, params: props.params })}
      {...props}
      className={className}
      target={target}
    >
      {children}
    </Link>
  );
}
